export default __webpack_public_path__ + "static/media/downarrow.30f8ce16.svg";